export const MODAL_NAMES = {
	absence: 'modalAbsence',
	deleteAbsence: 'modalDeleteAbsence',
	deleteExtraActivity: 'modalDeleteExtraActivity',
	protection: 'modalProtection',
	holdDown: 'modalHoldDown',
	traveling: 'modalTraveling',
	employmentType: 'employmentType',
	setHomeLocation: 'setHomeLocation',
	updateCrewLocation: 'updateLocation',
	updateAuxiliaryWAStatus: 'modalDeleteActivity',
	manualReconciliation: 'modalManualReconciliation',
	manageExtraActivity: 'manageExtraActivity',
	flow: 'flowModal',
	breakdownDetails: 'modalBreakdownDetails',
};
